/**
 *	Set the paths to always require
 */
requirejs.config({
	baseUrl: '/_jsapps/backstage',

	/* Runs the main.js file on default */
	deps: ["main"],
	
	paths: {
		text 	: "//payload.persona.co/libs/require/text.min",
		css 	: "//payload.persona.co/libs/require/css.min"
	}

});
define("main.bootstrap", function(){});

